<div class="fixed-button active">
  <a href="https://codedthemes.com/item/datta-able-angular/" target="_blank" class="btn btn-md btn-theme has-ripple">
    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
    Upgrade To Pro
  </a>
</div>
